import React from 'react';
import ModalV2, { DefaultFooterButtons } from '@/views/components/modals/ModalV2';
import { formatMessage } from '@/utils/i18n';
import { MODAL_SIZES } from '@/utils/constants';

type Props = {
  backdropClassName?: string;
  onCancel: () => void;
  onConfirm?: () => void;
  show?: boolean;
};

const ManualProxyReplacementWarningModal = ({ show, onCancel, onConfirm, ...rest }: Props) => {
  const basei18n = 'Portfolios.ManualProxyReplacementWarningModal';
  const body = <span>{formatMessage(`${basei18n}.Body`)}</span>;
  const title = `${basei18n}.Title`;

  const footerButtonsConfig: DefaultFooterButtons = {
    cancelLabelToLocalize: `${basei18n}.CancelButton`,
    cancelOnClick: onCancel,
    primaryLabelToLocalize: `${basei18n}.ConfirmButton`,
    primaryOnClick: onConfirm,
  };

  return (
    <ModalV2
      size={MODAL_SIZES.SM}
      modalClassName="body-sm"
      show={show}
      title={title}
      onClose={onCancel}
      body={body}
      defaultFooterButtons={footerButtonsConfig}
      {...rest}
    />
  );
};

export default ManualProxyReplacementWarningModal;
